module.exports = __webpack_public_path__ + "img/beka.4f31907d.jpg";